/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import * as BenchlingUtil from 'BenchlingUtil';
import DataConnector from 'connect/DataConnector';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SavingState} from 'constants/RegistryConstants';
import {GRID_SCHEMA_CLASS_TO_TYPE_TEXT, GridSchemaClass} from 'constants/SampleConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import SampleSchemaStore from 'samples/SampleSchemaStore';
import {ContainerSchema, GridSchema} from 'samples/storables/StorableSchemaConstants';
import SchemaSettingsPageContainer from 'schemas/SchemaSettingsPageContainer';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import GridSchemaSettings from './GridSchemaSettings';

class GridSchemaSettingsPageConnector extends DataConnector<GridSchemaSettingsProps, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [SampleSchemaStore];

  enhanceProps(): EnhancedProps {
    let newState: EnhancedProps = {
      containerSchemas: SampleSchemaStore.getContainerSchemas(this.props.registryId),
      savingState: SampleSchemaStore.getSavingState(),
    };
    if (this.props.gridSchemaId) {
      const gridSchema = SampleSchemaStore.getGridSchema(this.props.gridSchemaId, this.props.gridSchemaClass);
      newState = {...newState, gridSchema};
    }
    return newState;
  }
}

export interface GridSchemaSettingsProps {
  gridSchemaClass: GridSchemaClass;
  gridSchemaId?: string;
  ownerUrlId: string;
  registryId: string;
}
export interface EnhancedProps {
  containerSchemas?: Array<ContainerSchema> | null;
  gridSchema?: GridSchema | null;
  savingState: SavingState;
}

interface QueryingProps {
  isWritable: boolean;
}

export class GridSchemaSettingsPage extends React.Component<
  GridSchemaSettingsProps & EnhancedProps & QueryingProps
> {
  componentDidMount(): void {
    this._fetchGridSchemas();
  }

  componentDidUpdate(
    prevProps: GridSchemaSettingsProps & EnhancedProps & QueryingProps,
    prevState: any
  ): void {
    if (prevProps.gridSchemaClass !== this.props.gridSchemaClass) {
      this._fetchGridSchemas();
    }
    if (
      prevProps.savingState === SavingState.PENDING &&
      RegistryUtil.isSavingFinished(this.props.savingState)
    ) {
      SampleSchemaActions.resetSavingState();
    }
  }

  _fetchGridSchemas = (): void => {
    SampleSchemaActions.fetchAllContainerSchemas();
    SampleSchemaActions.fetchAllGridSchemas(this.props.gridSchemaClass);
  };

  _handleNavigateToGridSchemas = (): void => {
    BenchlingUtil.navigate(
      null,
      RegistryUtil.getRegistryGridSchemasUrl(
        this.props.ownerUrlId,
        this.props.registryId,
        this.props.gridSchemaClass
      )
    );
  };

  _handleCreate = (gridSchema: any): void => {
    SampleSchemaActions.createGridSchema(
      this.props.registryId,
      gridSchema,
      this.props.gridSchemaClass,
      this._handleNavigateToGridSchemas
    );
  };

  _handleUpdate = (gridSchema: any): void => {
    assert(this.props.gridSchemaId != null, 'gridSchemaId must exist for update.');
    if (this.props.gridSchemaId) {
      SampleSchemaActions.updateGridSchema(this.props.gridSchemaId, gridSchema, this.props.gridSchemaClass);
    }
  };

  _updateWindowTitle = (): void => {
    if (this.props.gridSchema) {
      BenchlingUtil.setWindowTitle(
        `${this.props.gridSchema.name} - ${
          GRID_SCHEMA_CLASS_TO_TYPE_TEXT[this.props.gridSchemaClass]
        } Schemas`
      );
    }
  };

  render(): JSX.Element {
    this._updateWindowTitle();

    return (
      <SchemaSettingsPageContainer
        onNavigateToListing={this._handleNavigateToGridSchemas}
        schema={this.props.gridSchemaId && this.props.gridSchema ? this.props.gridSchema : null}
        schemaType={this.props.gridSchemaClass as unknown as ModelTypeConstants}
      >
        {(this.props.gridSchemaId && !this.props.gridSchema) || !this.props.containerSchemas ? (
          <HorizontalThrobber />
        ) : (
          <GridSchemaSettings
            containerSchemas={this.props.containerSchemas}
            gridSchema={this.props.gridSchema}
            gridSchemaClass={this.props.gridSchemaClass}
            isBeingCreated={!this.props.gridSchemaId}
            isWritable={this.props.isWritable}
            onCreate={this._handleCreate}
            onUpdate={this._handleUpdate}
            registryId={this.props.registryId}
            ownerUrlId={this.props.ownerUrlId}
            savingState={this.props.savingState}
          />
        )}
      </SchemaSettingsPageContainer>
    );
  }
}

function QueryingGridSchemaSettingsPage(props: GridSchemaSettingsProps & EnhancedProps): JSX.Element {
  const isWritable = RegistryUtil.useIsRegistryWritableQuery(props.registryId);
  return <GridSchemaSettingsPage {...props} isWritable={isWritable} />;
}

export default GridSchemaSettingsPageConnector.connect(QueryingGridSchemaSettingsPage);
